import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { HomeSectionLabel } from '@constants';
import { LeaderBoardComponent } from '../../@shared/components/leaderboard/leaderboard.component';

@Component({
    selector: 'app-home-leaderboard',
    imports: [CommonModule, LeaderBoardComponent],
    templateUrl: './home-leaderboard.component.html',
    styleUrls: ['./home-leaderboard.component.scss'],
})
export class HomeLeaderboardComponent {
    /** h4 text for this section */
    title = HomeSectionLabel.LEADERBOARD;
}
